<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container-fluid products-bazr" >
                <template #default>   <m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard309","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":true,"productBrandProp":true,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":true,"productCategoryProp":true,"productStoresProp":true,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard309","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":true,"infinityLoading":false,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null},...{}}' :style='""' class="my-5 products-ar" ></m-products-3></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
